import api from '../../utils/ApiConfig';

export const getPartnerSummary = async (year, month = null) => {
  const params = { year };
  if (month) params.month = month;
  const qs = new URLSearchParams(params).toString();
  const response = await api.get(`/bo/billing/partner-summary?${qs}`);
  return response.data;
};

export const generatePartnerInvoice = async (partnerTokenId, year, month, orderIds = null) => {
  const data = { partner_token_id: partnerTokenId, year, month };
  if (orderIds && orderIds.length > 0) data.order_ids = orderIds;
  const response = await api.post('/bo/billing/partner-invoice/generate', data);
  return response.data;
};

export const sendPartnerInvoice = async (numFacture, customMessage = null) => {
  const data = { num_facture: numFacture };
  if (customMessage) data.custom_message = customMessage;
  const response = await api.post('/bo/billing/partner-invoice/send', data);
  return response.data;
};

export const updatePartnerPaymentStatus = async (numFacture, statuFacture) => {
  const response = await api.patch(`/bo/billing/partner-invoice/${numFacture}/payment`, {
    statu_facture: statuFacture,
  });
  return response.data;
};

export const downloadPartnerInvoiceUrl = (numFacture) =>
  `${api.defaults.baseURL}/bo/billing/partner-invoice/${numFacture}/download`;
